import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { PresentToAllSharp, PropaneSharp } from "@mui/icons-material";
import { validEmail } from "../../../../Constants/RegExp";
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { CreateBooking } from "./Requests";
import {PulseLoader } from "react-spinners";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StepFour = (props) => {
   const [firstName, setFirstName] = useState()
   const [lastName, setLastName] = useState()
   const [email, setEmail] = useState()
   const [mobile, setMobile] = useState()
   let bookingFormErrorsObj = { firstName: '', lastName: '', mobile: '', email: '' };
   const [formErrors, setFormErrors] = useState(bookingFormErrorsObj);
   const [isLoading, setIsLoading] = useState(false)
   const [sendReminder, setSendReminder] = useState()

      useEffect(() => {
         window.scrollTo(0,0)
     }, []);

   function OnFormSubmitClick(e, option)
   {
         e.preventDefault();
         var startDateTime = (new Date(props.date).setHours(Number((props.time).split(":")[0]),Number((props.time).split(":")[1]),0,0))
         
         let error = false;
         const formErrorObj = { ...bookingFormErrorsObj };
         if (firstName === '' || firstName === undefined || firstName === null) {
            formErrorObj.firstName = 'First name is required';
            error = true;
         }

         if (lastName === '' || lastName === undefined || lastName === null) {
            formErrorObj.lastName = 'Last name is required';
            error = true;
         }

         if(mobile !== undefined && mobile !== null)
            {
               if (mobile.length > 0) {
                  if (mobile.length !== 11)
                     {
                        formErrorObj.mobile = 'Invalid mobile number';
                        error = true;
                     }
                  }
            }

         if (email === '' || email === undefined || email === null) {
            formErrorObj.email = 'Email is required';
            error = true;
         } else{
            if (!validEmail.test(email))
               {
                  formErrorObj.email = 'Invalid Email';
                  error = true;
               }
            }
            
            setFormErrors(formErrorObj);
            if (error) {
               return;
            } else
            {

               setTimeout(() => {
                  window.scrollTo({ top:0, behavior: 'smooth'})
               })
               if (option === "book now")
               {
                  setIsLoading(true)
                  props.setEmail(email)
                  
                  CreateBooking(props.barber.barberId, props.service.serviceId, startDateTime, props.timeId, props.service.duration, firstName, lastName, email, mobile, sendReminder).then((res) => {
                     if (res.status === 200)
                     {
                        setIsLoading(false)
                        props.bookingResult('success')
                     } else
                     {
                        setIsLoading(false)
                        props.bookingResult('failed')
                     }
                  }).catch((error) => {
                     setIsLoading(false)
                     props.bookingResult('failed')
                  })
               }
               else{
                  console.log('else')
                  props.setEmail(email)
                  props.setFirstName(firstName)
                  props.setLastName(lastName)
                  props.setMobile(mobile)
                  props.goTo(4)
               }

            }

         }

   return (
      <div className="booking-portal-step-wrapper">

         <div style={{marginTop:"2rem"}}>
            <h2 style={{marginBottom:0, marginLeft:"auto", marginRight:"auto"}} className="grid-title">Details</h2>
            <section>
               <div>
                  {isLoading ?       
                  
                  <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
               <div style={{marginTop:"2rem"}}>        
                  <PulseLoader 
                  color={'#333'}
                  loading={isLoading}
                  size={25}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  />
               </div>
            </div> 
            
            :

        

    <div className="appointment-container">
      <form className="appointment-form">
         <IconButton aria-label="delete" size="large">
            <ArrowBackIcon className="back-arrow" onClick={() => props.goTo(2)} />
         </IconButton>
         <div className="service-info appointment-summary">
         <p>
            Your {props.service.name} appointment with {props.barber.name} is on {(new Date(props.date)).toDateString()} at {props.time}
         </p>
         </div>
        <div className="form-row">
          <div className="form-group appointment-booking-details">
            <label htmlFor="firstName">First Name<span>*</span></label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              required
              onChange={(e) => setFirstName(e.target.value)}
            />
            {formErrors.firstName && <div className="mt-2 text-danger fs-12">{formErrors.firstName}</div>}
          </div>
          <div className="form-group appointment-booking-details">
            <label htmlFor="lastName">Last Name<span>*</span></label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              required
              onChange={(e) => setLastName(e.target.value)}
            />
            {formErrors.lastName && <div className="mt-2 text-danger fs-12">{formErrors.lastName}</div>}
          </div>
        </div>
         <div className="form-row">
          <div className="form-group appointment-booking-details">
            <label htmlFor="email">Email<span>*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            {formErrors.email && <div className="mt-2 text-danger fs-12">{formErrors.email}</div>}
          </div>
          <div className="form-group appointment-booking-details">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
            {formErrors.mobile && <div className="mt-2 text-danger fs-12">{formErrors.mobile}</div>}
          </div>
        </div>
        <div style={{display:"flex", padding:0}} className='form-check check-switch custom-checkbox mb-2'>
          <input
            // style={{width:"0.25rem", height:"0.25rem"}}
            type='checkbox'
            className='form-check-inputt'
            id='showBusinessHoursCheck'
            defaultChecked={false}
            onChange={(e) => { setSendReminder(e.target.checked);}}
          />
          <label className='form-check-label' htmlFor='showBusinessHoursCheck'>
              Send me a 24hr email reminder
          </label>
        </div>
        {((props.terms !== "") && (props.terms !== null) && (props.terms !== undefined))
        ?
         <div className="service-info">
         <h4>Terms and Conditions</h4>
         <p>{props.terms}</p>
         <p style={{fontSize:"0.8rem"}}>By proceeding with your booking your are agreeing with the terms and conditions above.</p>
         </div>
         :
         <></>
        }
               <div className="text-end toolbar toolbar-bottom p-2">
               {((props.service.onlinePaymentAmount === null) || (props.service.onlinePaymentAmount === undefined) || (props.service.onlinePaymentAmount === 0.00) || (props.acceptingOnlinePayments === false))
               ?
               <button className="select-btn" onClick={(e) => {OnFormSubmitClick(e, "book now")}}>Book Now</button>
               :
               <button className="select-btn" onClick={(e) => {OnFormSubmitClick(e, "pay now")}}>Go To Payment</button>
            }
            </div>
      </form>
    </div>

                  }
               </div>
            </section>
      
      

            </div>
      </div>
   );
};

export default StepFour;
